module.exports = __webpack_public_path__ + "static/media/400125_02.8087f879.png";